/* src/app/private/components/active-directory-config/active-directory-config-details/active-directory-config-details.component.scss */
/*# sourceMappingURL=active-directory-config-details.component.css.map */
